import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ItemView from '../utils/ItemView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';
import { Link } from 'react-router-dom';

class MemberDetailApp extends React.Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        console.log(this.props);

        this.state = {
            ty: 2,
            tac: this.props.match.params["id"] || "",
            list: []
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    getData() {
        var tmpData = {
            ty: this.state.ty,
            tac: this.state.tac
        };
        API.GetMembers(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index, value) {
        // console.log(index,value);
        let list = Object.assign({}, this.state.list);
        switch (list[index].type) {
            case Enums.E_ITEM.CITY_AREA:
                list[index].data.value.city = value.city;
                list[index].data.value.area = value.area;
                break;
            default:
                list[index].data.value = value;
                break;
        }

        this.setState({ list: list });
    }

    onDataUpdated(data) {
        if (data && data.data && data.data.length > 0) {

            const tmpObj = data.data[0];
            const tmp = [
                {
                    type: Enums.E_ITEM.TEXT,
                    data: {
                        label: "暱稱",
                        value: tmpObj.info.display_name,
                        placeholder: ""
                    }
                }, {
                    type: Enums.E_ITEM.TIME,
                    col: 1,
                    data: {
                        label: "註冊時間",
                        value: tmpObj.created_at
                    }
                }, {
                    type: Enums.E_ITEM.NUMBER,
                    data: {
                        label: "手機",
                        value: tmpObj.bind.p.va
                    }
                }, {
                    type: Enums.E_ITEM.TIME,
                    col: 1,
                    data: {
                        label: "最近登入",
                        value: tmpObj.last_login
                    }
                }, {
                    type: Enums.E_ITEM.TEXT,
                    data: {
                        label: "生日",
                        value: tmpObj.info.birthday,
                        placeholder: ""
                    }
                }, {
                    type: Enums.E_ITEM.NUMBER,
                    col: 1,
                    data: {
                        label: "點數",
                        value: tmpObj.points
                    }
                }, {
                    type: Enums.E_ITEM.GENDER,
                    data: {
                        label: "性別",
                        value: tmpObj.info.gender
                    }
                }, {
                    type: Enums.E_ITEM.CITY_AREA,
                    col: 1,
                    data: {
                        label: "居住地",
                        value: {
                            city: tmpObj.info.live_city,
                            area: tmpObj.info.live_dist
                        },
                        placeholder: ""
                    }
                }, {
                    type: Enums.E_ITEM.TEXT,
                    data: {
                        label: "信箱",
                        value: tmpObj.info.email,
                        placeholder: ""
                    }
                }, {
                    type: Enums.E_ITEM.CITY_AREA,
                    col: 1,
                    data: {
                        label: "戶籍地",
                        value: {
                            city: tmpObj.info.birth_city,
                            area: tmpObj.info.birth_dist
                        },
                        placeholder: ""
                    }
                }, {
                    type: Enums.E_ITEM.EDU,
                    data: {
                        label: "教育程度",
                        value: tmpObj.info.education
                    }
                }, {
                    type: Enums.E_ITEM.JOB,
                    col: 1,
                    data: {
                        label: "職業",
                        value: tmpObj.info.job
                    }
                }
            ];
            this.setState({
                list: tmp,
                oriData: tmpObj
            })
        }
    }

    onSave() {
        console.log("onSave");
        let tmpObj = Object.assign(this.state.oriData);
        const list = this.state.list;

        /*{
            "data": [
                {
                    "devID": "0",
                    "bind": {
                        "p": {
                        "ct": "1451805879000",
                        "va": "886903556371"
                        },
                        "g": {
                        "ct": 0,
                        "va": ""
                        },
                        "fb": {
                        "ct": 0,
                        "va": ""
                        },
                        "l": {
                        "ct": 0,
                        "va": ""
                        }
                    },
                    "enable": "1",
                    "last_login": "0",
                    "accID": "AbBmEepO",
                    "created_at": "1451805856000",
                    "points": "161",
                    "info": {
                        "birthday": "1997-04-23",
                        "live_city": 6,
                        "birth_city": 6,
                        "education": 0,
                        "gender": 1,
                        "live_dist": 135,
                        "display_name": "ant",
                        "job": 0,
                        "email": "",
                        "birth_dist": 135
                    }
                    }
                ]
        }*/
        tmpObj.info.display_name = list[0].data.value; //暱稱
        tmpObj.created_at = list[1].data.value;      //註冊時間
        tmpObj.bind.p.va = list[2].data.value;       //手機
        tmpObj.last_login = list[3].data.value;      //最近登入
        tmpObj.info.birthday = list[4].data.value;   //生日
        tmpObj.points = list[5].data.value;          //點數
        tmpObj.info.gender = list[6].data.value;     //性別
        tmpObj.info.live_city = list[7].data.city;  //居住地       
        tmpObj.info.live_dist = list[7].data.area;

        tmpObj.info.email = list[8].data.value;      //信箱
        tmpObj.info.birth_city = list[9].data.city;  //戶籍地         
        tmpObj.info.birth_dist = list[9].data.area;

        tmpObj.info.education = list[10].data.value;  //教育程度
        tmpObj.info.job = list[11].data.value;        //職業

        const header = {
            ty: 2,
            tac: this.state.tac
        };
        const body = { data: [tmpObj] };
        console.log(header, body);
        alert("沒有儲存api");
        // API.GetMembers(header, function(res){
        //     console.log(res);
        // }, body);
    }

    onDelete() {
        console.log("onDelete");
        alert("沒有delete api");
    }

    render() {
        const { list, tac } = this.state,
            { onListViewClicked, onSave, onDelete } = this;
        return (
            <div>
                <ItemView
                    title={"會員: " + tac}
                    onUpdate={onListViewClicked}
                    onSave={onSave}
                    onDelete={onDelete}
                    disablePreview={true}
                    data={list} />
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <button className="btn btn-outline-info" disabled>填過的問卷 (API待補)</button>
                        </div>
                        <div className="col-12 col-sm-6">
                            <Link className="btn btn-outline-info" to={"/member/redeem/" + tac}>換過的禮物</Link>
                        </div>
                        <div className="col-12 col-sm-6">
                            <button className="btn btn-outline-info" disabled>看過的廣告 (API待補)</button>
                        </div>
                        <div className="col-12 col-sm-6">
                            <Link className="btn btn-outline-info" to={"/member/point/" + tac}>點數紀錄</Link>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(MemberDetailApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberDetailApp))